import React, { useState, useRef, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
//styles
import styles from 'src/asset/scss/styles/notify.module.scss';
//hook
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//CompWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
import ActiveButtonWrapper from 'src/webapp/views/wrapper/ActiveButtonWrapper';
//Comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import Element from 'src/webapp/views/wrapper/Element';
import BannerList from './BannerList';
import InViewData from 'src/webapp/views/component/data/InViewData';//데이터로드확인

export default function Banner() {
    //하위컴포넌트ref
    const childRef = useRef({});
    const { axiosPostHandler } = useAxiosHook();//axios
    /* ==================== 배너리스트 ==================== */
    //배너리스트API
    const [ siteBannerList ,setSiteBannerList ] = useState([]); 
    const isLock = useRef(false);
    const pageRef = useRef(20);
    const siteBannerListAPI = async(type) => {//type- 0.최초로딩, 1.무한로딩, 3.등록후로딩
        if(isLock.current) { return; }
        try{
            isLock.current = true;
            const DATA = { TYP:1, STATE:0, ROWNUM:type === 1 ? pageRef.current : 20 };
            const result = await axiosPostHandler(`siteBannerListForAdmin.do`, DATA);
            if(!result) { return; }
            if(result.message === "INVALID_DATA") { 
                if(type === 0) { setSiteBannerList([]); }
                pageRef.current = null;
            }
            if(result.message === "SUCCESS") { 
                if(type === 0 || type === 3) { pageRef.current = 20; }
                setSiteBannerList(type !== 1 ? result.data : siteBannerList.concat(result.data));
                pageRef.current = result.data.length < 20 ? null : pageRef.current + 20;
            }
        }finally{
            isLock.current = false;
        }
    }
    useEffect(() => {
        siteBannerListAPI(0);//배너리스트API
    }, []);
    //infinityObserver
    const [ inViewRef, inView ] = useInView({ threshold: .5 });
    useEffect(() => {
        if (inView && (pageRef.current != null)) { siteBannerListAPI(1); }//배너리스트API
    }, [inView]);
    /* ==================== 배너리스트 ==================== */

    return ( 
        <>
        <Section>
            <Menu />{/* 메뉴 */}
            <Container>
                <FixedPanel>
                    <Titlebar title={`배너 관리`}  dept={[{label:'기타'}, {label:'배너 관리'}]} />{/* 상단타이틀 */}
                </FixedPanel>
                <FlickPanel className={styles.flickPanel}>
                    <ActiveButtonWrapper>
                        <Element tag={`div`} >
                            <Link to={'reg'}><span>배너 등록</span></Link>
                        </Element>
                    </ActiveButtonWrapper>
                <BannerList ref={childRef} list={siteBannerList} setList={setSiteBannerList} onLoad={siteBannerListAPI} />
                {siteBannerList.length > 0 && pageRef.current != null ? <div ref={inViewRef}><InViewData inView={true} /></div>
                : pageRef.current === null ? <InViewData readAll={true} /> 
                : null}
                </FlickPanel>
            </Container>
        </Section>
        </>
        )}